export function RaiseHeroSection() {
  return (
    <section className="bg-muted/30 py-16 sm:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="mx-auto max-w-3xl text-center">
          <h1 className="text-4xl font-bold tracking-tight text-balance md:text-5xl">
            Raise Capital for Your Business
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground">
            Equity crowdfunding allows you to raise funds from your customers, community,
            and supporters. Get distribution and grow your private company.
          </p>
        </div>
      </div>
    </section>
  );
}
